import { cn } from '@/utils/helpers/classnames'

interface IProps {
  title: string
  className?: string
}
const FormHeader = ({ title, className = '' }: IProps) => {
  return (
    <h2
      className={cn(
        'py-4 mb-8 border-b font-semibold text-lg border-gray-100',
        className
      )}
    >
      {title}
    </h2>
  )
}

export default FormHeader
